module.exports = __webpack_public_path__ + "static/img/samajuri (5).ebf9406.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (5).jpg
// module id = iiT0
// module chunks = 0